// Client-side mirror of the backend's ingest limits (ultimo-bots-backend
// src/controller/ingest_limits.py). The backend is the enforcer — it refuses an
// oversized file for every source and stores a customer-facing failure_reason on
// the row; the portal uses the same number to refuse early, in the upload dialog
// and in the Drive / OneDrive pickers, so the customer sees the message before a
// row is even created. Keep the two in sync.
export const MAX_SOURCE_FILE_MB = 10;
export const MAX_SOURCE_FILE_BYTES = MAX_SOURCE_FILE_MB * 1024 * 1024;

// Size of a picked/listed file where the source reports one: Google Picker docs
// carry `sizeBytes`, our own listings (OneDrive browser, folder resolves) carry
// `size`. Native Google Docs/Sheets report none (null) — they are checked
// server-side after export.
export function fileSizeOf(file) {
  const raw = file?.sizeBytes ?? file?.size ?? file?.size_bytes;
  const n = Number(raw);
  return Number.isFinite(n) && n > 0 ? n : null;
}

export function formatMB(bytes) {
  if (bytes === null || bytes === undefined) return '';
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

// Split a list of files into those the cap allows and those it refuses.
export function splitTooLarge(files) {
  const ok = [];
  const tooLarge = [];
  for (const f of files || []) {
    const size = fileSizeOf(f);
    (size !== null && size > MAX_SOURCE_FILE_BYTES ? tooLarge : ok).push(f);
  }
  return { ok, tooLarge };
}

// One human line naming the refused files, for the pickers' notice.
export function describeTooLarge(files, t) {
  const names = files.map((f) => `${f.name || f.id} (${formatMB(fileSizeOf(f))})`).join(', ');
  return t('import_files_too_large', {
    count: files.length,
    max: MAX_SOURCE_FILE_MB,
    names,
    defaultValue: '{{count}} file(s) skipped because they are larger than {{max}} MB: {{names}}. Files up to {{max}} MB are supported.',
  });
}
